export const countries = [
    {
        "key": "core-data.countries.uk",
        "defaultLabel": "UK",
        "flag": "UK"
    },
    {
        "key": "core-data.countries.germany",
        "defaultLabel": "Germany",
        "flag": "DE"
    },
    {
        "key": "core-data.countries.canada",
        "defaultLabel": "Canada",
        "flag": "CA"
    },
    {
        "key": "core-data.countries.usa",
        "defaultLabel": "USA",
        "flag": "US"
    }
]

export const getCountryLabel = (countryKey) => {
    const country = countries.find(country => country.key === countryKey);
    return country ? country.defaultLabel : countryKey;
}